import React, { useEffect, useState } from 'react';
import { BASE_URL } from "../../url";
import { MDBDataTable } from 'mdbreact';
import { Link, useParams } from "react-router-dom";
import * as XLSX from 'xlsx'; 
import { Spinner } from 'react-bootstrap';

function ViewParticipantsPage() {
  const [getAllTrekkers, setAllTrekkers] = useState(null);
  const [trekDetails, setTrekDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const { trekId } = useParams();

  useEffect(() => {
    fetch(`${BASE_URL}/viewAllParticipants/${trekId}`)
      .then(response => {
        response.json().then(getAllTrekkers => {
          setAllTrekkers(getAllTrekkers);
          setLoading(false);
        });
      });
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/trekDetails/${trekId}`)
      .then(response => {
        response.json().then(trekDetails => {
          setTrekDetails(trekDetails);
        });
      });
  }, []);

  const handleDownloadExcel = () => {

    const dataForExcel = getAllTrekkers.map(trekker => ({
      'First Name': trekker.firstName,
      'Last Name': trekker.lastName,
      'Phone': trekker.phoneNumber,
      'WhatsApp Number': trekker.whatsAppNumber,
      'Email': trekker.email,
      'Age': trekker.age
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Participants');

    XLSX.writeFile(workbook, `${trekDetails.trekName}_Participants.xlsx`);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" role="status" className='trekNameWhite'></Spinner>
      </div>
    ); 
  }

  if (getAllTrekkers && trekDetails) {
    const data = {
      columns: [
        {
          label: 'First Name',
          field: 'firstName',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Last Name',
          field: 'lastName',
          sort: 'asc',
          width: 270
        },
        {
          label: 'Phone',
          field: 'phoneNumber',
          sort: 'asc',
          width: 200
        },
        {
          label: 'WhatsApp Number',
          field: 'whatsAppNumber',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Email',
          field: 'email',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Age',
          field: 'age',
          sort: 'asc',
          width: 150
        }
      ],
      rows: getAllTrekkers
    };

    return (
      <>
        <h1 className='trekNameWhite aboutTop'>{trekDetails.trekName}</h1>
        <div className="table-container">
          <MDBDataTable
            paging={false}
            data={data}
          />
        </div>
        <button onClick={handleDownloadExcel} className="btn-get-excel">
          DOWNLOAD EXCEL
        </button>
      </>
    )    
  }

  return null;
}

export default ViewParticipantsPage;